module.exports = __webpack_public_path__ + "Kastelov - Axiforma Bold.otf";